<template>
  <v-scale-screen width="1920" height="1080" :fullScreen="true">
    <div id="monitoringRight">
      <div class="right_header"></div>
      <div class="row-style">
        <div class="right_div1">
          <div id="chart1"></div>
        </div>
        <div class="right_div2">
          <div id="chart2"></div>
        </div>
      </div>
      <div class="row-style">
        <div class="right_div3">
          <el-select v-model="carbonRegion" placeholder="" :popper-append-to-body="false" @change="carbonChange">
            <el-option v-for="item in regionOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <div id="chart3"></div>
        </div>
        <div class="right_div4">
          <!-- <el-select
            v-model="capacity"
            style="right: 184px"
            :popper-append-to-body="false"
            placeholder="容量"
            @change="capacityChange"
          >
            <el-option
              v-for="item in capacityOptions"
              :key="item.id"
              :label="item.grossRatedCapacity"
              :value="item.grossRatedCapacity"
            >
            </el-option>
          </el-select> -->
          <!-- <el-select @change="typeChange" v-model="type" placeholder="类型" style="width: 122px" filterable
            :popper-append-to-body="false">
            <el-option v-for="item in typeOptions" :key="item.id" :label="item.transformerModel"
              :value="item.transformerModel">
            </el-option>
          </el-select> -->
          <div id="chart4"></div>
        </div>
        <div class="right_div5">
          <el-date-picker style="width: 122px" class="z-index" v-model="monthlyDay" type="date" placeholder="日"
            value-format="yyyy-MM-dd" :clearable="false" popper-class="echarts-picker"
            @change="dayChange"></el-date-picker>
          <el-date-picker v-model="monthlyMonth" style="right: 182px; width: 106px" type="month" value-format="yyyy-MM"
            placeholder="月" :clearable="false" popper-class="echarts-picker" @change="monthChange">
          </el-date-picker>
          <el-date-picker v-model="monthlyYear" style="right: 298px; width: 86px" value-format="yyyy" :clearable="false"
            type="year" placeholder="年" popper-class="echarts-picker" @change="yearChange">
          </el-date-picker>
          <div id="chart5"></div>
        </div>
      </div>
      <div class="row-style">
        <div class="right_div6">
          <el-select v-model="electricityRegion" placeholder="" :popper-append-to-body="false" @change="regionChange">
            <el-option v-for="item in regionOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <div id="chart6"></div>
        </div>
        <div class="right_div7">
          <el-select v-model="powerRegion" placeholder="" :popper-append-to-body="false" @change="electricityChange">
            <el-option v-for="item in regionOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker v-model="electricityMonth" style="right: 140px; width: 106px" value-format="yyyy-MM"
            type="month" placeholder="月" :clearable="false" popper-class="echarts-picker" @change="electricityChange">
          </el-date-picker>
          <!-- <el-date-picker
            v-model="electricityYear"
            style="right: 256px; width: 86px"
            type="year"
            value-format="yyyy"
            placeholder="年"
            popper-class="echarts-picker"
            @change="electricityChange"
          >
          </el-date-picker> -->
          <div id="chart7"></div>
        </div>
        <div class="right_div8">
          <el-select v-model="produceRegion" placeholder="" :popper-append-to-body="false" @change="produceChange">
            <el-option v-for="item in regionOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker v-model="produceMonth" style="right: 140px; width: 106px" type="month" value-format="yyyy-MM"
            placeholder="月" :clearable="false" popper-class="echarts-picker" @change="produceChange">
          </el-date-picker>
          <!-- <el-date-picker
            v-model="produceYear"
            style="right: 256px; width: 86px"
            type="year"
            value-format="yyyy"
            placeholder="年"
            popper-class="echarts-picker"
            @change="produceChange"
          >
          </el-date-picker> -->
          <div id="chart8"></div>
        </div>
      </div>
      <!-- <div class="monitoringFooter"></div> -->
    </div>
    <div class="left_nav" @click="jump()"></div>
  </v-scale-screen>
</template>
<script>
import * as echarts from "echarts";
import { monitorApi } from "@/api/monitor.js";
import xDate from "../../utils/ecahrtXdate.js";
export default {
  data() {
    return {
      regionOptions: [
        { label: "分中心", value: 2 },
        { label: "地区", value: 1 }
      ],
      capacityOptions: [],
      typeOptions: [],
      carbonRegion: 2,
      electricityRegion: 2,
      produceRegion: 2,
      powerRegion: 2,
      capacity: "",
      type: "",
      produceMonth: null,
      produceYear: null,
      electricityYear: null,
      electricityMonth: null,
      monthlyDay: null,
      monthlyMonth: null,
      monthlyYear: null,
      requestType: 0,
      staTime:'',
      endTime:'',
    };
  },
  //懒得封装方法，直接写生命周期里了，习惯代码规范的可以自行封装放入方法
  created() {
    const date = new Date(); // 获取当前时间
    let year = date.getFullYear(); // 获取当前年份
    let month = date.getMonth() + 1; // 获取当前月份
    let day = date.getDate() + 1; // 获取当前月份
    this.produceYear = `${year}`;
    // this.monthlyYear = `${year}`;
    this.electricityYear = `${year}`;
    // this.monthlyMonth = `${year}-${month}`;
    this.monthlyDay=`${year}-${month}-${day -1}`
    if (month < 10) {
      this.produceMonth = `${year}-0${month}`;
      this.electricityMonth = `${year}-0${month}`;
      this.monthlyDay=`${year}-0${month}-${day -1}`
      if(day<10){
        this.monthlyDay=`${year}-0${month}-0${day -1}`
      }
    } else {
      this.produceMonth = `${year}-${month}`;
      this.electricityMonth = `${year}-${month}`;
    }
    this.queryType();
    
  },
  mounted() {
    this.queryCapacity();
    this.init();
  },
  methods: {
    init() {
      this.queryMonthlyElectricity();
      this.queryProductionEnergy();
      this.queryLastAnalysis();
      this.queryMonthlyLast();
      this.queryTotalElectricity();
      this.queryElectricity();
      this.queryCarbonEmission();
    },
    //跳转到第一屏幕
    jump() {
      this.$router.push("/monitoringLeft");
    },
    //3. 当月累计碳排情况统计
    carbonChange() {
      this.queryCarbonEmission();
    },
    //4. 当月能耗分析情况统计
    capacityChange() {
      this.type = "";
      this.queryEnergyConsumption();
    },
    typeChange() {
      this.queryEnergyConsumption();
    },
    // 5.用电量同比分析
    yearChange() {
      this.monthlyMonth = "";
      this.monthlyDay = "";
      this.queryLastAnalysis();
    },
    monthChange() {
      this.monthlyYear = "";
      this.monthlyDay = "";
      this.queryLastAnalysis();
    },
    dayChange() {
      this.monthlyYear = "";
      this.monthlyMonth = "";
      this.queryLastAnalysis();
    },
    //6. 当月用电量情况统计
    regionChange() {
      this.queryMonthlyElectricity();
    },
    // 7. 月用电量同比分析
    electricityChange() {
      this.queryMonthlyLast();
    },
    //8. 生产用能前十排名
    produceChange() {
      this.queryProductionEnergy();
    },
    // 额定容量
    queryCapacity() {
      monitorApi.queryCapacity().then((res) => {
        if (res.code === 200) {
          this.capacityOptions = res.data;
          this.capacity = res.data[0].grossRatedCapacity;
          this.queryEnergyConsumption(this.capacity);
        }
      });
    },
    // 设备类型
    queryType() {
      monitorApi.queryType().then((res) => {
        if (res.code === 200) {

          this.typeOptions = res.data;
          if (res.data.length > 0) {
            this.type = res.data[0].transformerModel
            this.queryEnergyConsumption();
          }

        }
      });
    },
    // 截取对象属性
    intercept(objct, start, end) {
      /* 利用entries 将对象转换成二维数组*/
      /* 利用slice 进行截取*/
      let Index_0 = Object.entries(objct).slice(start, end);

      /* 利用fromEntries 将二维数组再转换为对象*/
      let Index_1 = Object.fromEntries(Index_0);

      /*返回对象*/
      return Index_1;
    },
    // 1.总用电量实时情况统计
    queryTotalElectricity() {
      monitorApi.queryTotalElectricity().then((res) => {
        let object = res[0];
        let xAxisData = [];
        let seriesData = [];
        for (const key in object) {
          xAxisData.push(key);
          if (object[key]) {
            seriesData.push(object[key]);
          } else {
            seriesData.push(`0`);
          }
        }
        this.setchart1(xAxisData, seriesData);
      });
    },
    // 2.用电量统计
    queryElectricity() {
      monitorApi.queryElectricity().then((res) => {
        let object = res[0];
        let xAxisData = [];
        let seriesData = [];
        for (const key in object) {
          xAxisData.push(key);
          if (object[key]) {
            seriesData.push(object[key]);
          } else {
            seriesData.push(`0`);
          }
        }
        this.setchart2(xAxisData, seriesData);
      });
    },
    getMonthStartAndEnd(el) {
      let date;
      if(el){
        date = new Date(el);
      }else{
        date = new Date();
      }
    const year = date.getFullYear();
    const month = date.getMonth() + 1; 
    const firstDay = new Date(year, month - 1, 2); 
    const lastDay = new Date(year, month, 1); 

    const formatDate = (d) => {
        return d.toISOString().slice(0, 10);
    };
    this.staTime = formatDate(firstDay) + ' 00:00:00';
    this.endTime= formatDate(lastDay) + ' 23:59:59';
    // console.log('~~~~~~~~~~',this.staTime,this.endTime);
   
    },
    //3. 当月累计碳排情况统计
    queryCarbonEmission() {
      this.getMonthStartAndEnd()
      let params={ 
        type: this.carbonRegion,
        monthStart: this.staTime,
        monthEnd: this.endTime,

       }

      monitorApi
        .queryCarbonEmission(params)
        .then((res) => {
          // let object = res[0];
          let xAxisData = [];
          let seriesData = [];
          res.forEach((element) => {
            for (const key in element) {
              xAxisData.push(key);
              if (element[key]) {
                seriesData.push(element[key]);
              } else {
                seriesData.push(`0`);
              }
            }
          });

          this.setchart3(xAxisData, seriesData);
        });
    },

    // 4.当月能耗分析情况统计
    queryEnergyConsumption(capacity) {
      let params = {
        transformerModel: '',
        monthStart: '',
        monthEnd: '',
      }
      let currentDate = new Date();
      // 获取当月第一天
      let firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      // 获取当月最后一天，下个月第一天的前一天
      let lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      params.monthStart = this.formatDate(firstDayOfMonth) + ' ' + '00:00:00'
      params.monthEnd = this.formatDate(lastDayOfMonth) + ' ' + '23:59:59'

      monitorApi.queryEnergyConsumption(params).then((res) => {
        // let object = res[0];
        let xAxisData = res.data.map(item => {
          if (item.nowTime && typeof item.nowTime === 'string' && item.nowTime.length >= 10) {
            return item.nowTime.substring(0, 10);
          } else {
            return ''; // 或者您可以根据实际情况返回其他默认值
          }
        });
        let seriesData = res.data.map(item => item.onceEpaddIns);
        // for (const key in object) {
        //   xAxisData.push(key);
        //   if (object[key]) {
        //     seriesData.push(object[key]);
        //   } else {
        //     seriesData.push(`0`);
        //   }
        // }
        this.setchart4(xAxisData, seriesData);
      });
    },

    formatDate(date) {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从 0 开始计数，需要 +1
  const day = ('0' + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
},
    // 5.用电量同比分析
    queryLastAnalysis() {
      let params = {
        dayStart:'',
        dayEnd:'',
        monthStart:'',
        monthEnd:'',
        yearStart:'',
        yearEnd:'',
      };
      if (this.monthlyYear) {
        // params.year = this.monthlyYear;
        console.log('this.monthlyYear;',this.monthlyYear);
        // this.getMonthStartAndEnd(this.monthlyYear)
        params.yearStart=this.formatDate(new Date(this.monthlyYear, 0, 1)) + ' 00:00:00'
        params.yearEnd=this.formatDate(new Date(this.monthlyYear, 11, 31)) +' 23:59:59'
      }
      if (this.monthlyMonth) {
        this.getMonthStartAndEnd(this.monthlyMonth)
        params.monthStart=this.staTime
        params.monthEnd=this.endTime
      }
      if (this.monthlyDay) {
       console.log(this.monthlyDay);
       params.dayStart=this.monthlyDay + ' 00:00:00'
       params.dayEnd=this.monthlyDay + ' 23:59:59'
      }
      monitorApi.yearMonthDay(params).then((res) => {
        let object = res.lastYear;
        let object2 = res.thisYear;
        let thisSeriesData = []; 
        let lastSeriesData = []; 
        let xAxisData = []; 
        console.log(object);
        console.log(object2);
        object.forEach(item=>{
          console.log(item.nowTime);
          if(this.monthlyYear){
            xAxisData.push(item.nowTime.substring(0,10))
            lastSeriesData.push(item.yesterday)
          }
          if (this.monthlyMonth){
            xAxisData.push(item.nowTime.substring(0,7))
            lastSeriesData.push(item.yesterday)
          }
          if (this.monthlyDay){
            xAxisData.push(item.nowTime.substring(0,16))
            lastSeriesData.push(item.yesterday)
          }
        })
        object2.forEach(item=>{
            thisSeriesData.push(item.yesterday)
        })
        console.log(xAxisData);
        // object.forEach(element=>{
        //   for (const key in element) {
        //       // xAxisData.push(key);
        //       // console.log(key);
        //       if (element[key]) {
        //         thisSeriesData.push(element[key]);
        //       } else {
        //         thisSeriesData.push(`0`);
        //       }
        //     }
        // })
       
        
        this.setchart5(xAxisData, lastSeriesData, thisSeriesData);
      });
    },
    // queryThisAnalysis(lastSeriesData) {
    //   let params = {
    //     type: 1,
    //   };
    //   if (this.monthlyYear) {
    //     params.year = this.monthlyYear;
    //   }
    //   if (this.monthlyMonth) {
    //     let year = this.monthlyMonth.slice(0, 4);
    //     params.year = Number(year);
    //     let month = this.monthlyMonth.slice(-2);
    //     params.month = Number(month);
    //   }
    //   if (this.monthlyDay) {
    //     let year = this.monthlyDay.slice(0, 4);
    //     params.year = Number(year);
    //     let month = this.monthlyDay.slice(5, 7);
    //     params.month = Number(month);
    //     let day = this.monthlyDay.slice(-2);
    //     params.day = Number(day);
    //   }
    //   monitorApi.queryMonthlyAnalysis(params).then((res) => {
    //     let object = res[0];
    //     let xAxisData = [];
    //     let thisSeriesData = [];
    //     for (const key in object) {
    //       if (params.day && params.month && params.year) {
    //         xAxisData.push(`${key}时`);
    //       } else if (params.month && params.year) {
    //         xAxisData.push(`${key}日`);
    //       } else {
    //         xAxisData.push(`${key}月`);
    //       }
    //       thisSeriesData.push(object[key]);
    //     }
    //     this.setchart5(xAxisData, lastSeriesData, thisSeriesData);
    //   });
    // },
    //6. 当月用电量情况统计
    queryMonthlyElectricity() {
      this.getMonthStartAndEnd()
      let params={ 
        type: this.electricityRegion,
        monthStart: this.staTime,
        monthEnd: this.endTime,

       }
      monitorApi
        .queryMonthlyElectricity(params)
        .then((res) => {
          let xAxisData = [];
          let seriesData = [];
          res.forEach((element) => {
            for (const key in element) {
              xAxisData.push(key);
              if (element[key]) {
                seriesData.push(element[key]);
              } else {
                seriesData.push(`0`);
              }
            }
          });
          
          this.setchart6(xAxisData, seriesData);
        });
    },
    // 7. 月用电量同比分析
    queryMonthlyLast() {
      this.getMonthStartAndEnd(this.electricityMonth)
      let params = {
        // flage: this.powerRegion,
        type: this.powerRegion,
        monthStart: this.staTime,
        monthEnd: this.endTime,
      };
      // if (this.electricityMonth) {
      //   let month = this.electricityMonth.slice(-2);
      //   params.month = Number(month);
      //   let year = this.electricityMonth.slice(0, 4);
      //   params.year = Number(year);
      // }
      monitorApi.queryMonthlyAnalysis(params).then((res) => {
        let object = res.lastYear;
        let object2 = res.thisYear;
        let thisSeriesData = []; 
        let lastSeriesData = []; 
        let xAxisData = []; 
        object.forEach(element=>{
          for (const key in element) {
              // xAxisData.push(key);
              // console.log(key);
              if (element[key]) {
                thisSeriesData.push(element[key]);
              } else {
                thisSeriesData.push(`0`);
              }
            }
        })
        object2.forEach(element=>{
          for (const key in element) {
              xAxisData.push(key);
              if (element[key]) {
                lastSeriesData.push(element[key]);
              } else {
                lastSeriesData.push(`0`);
              }
            }
        })
        // console.log('~~~速',xAxisData);
        // console.log('~~~速',lastSeriesData);

        
        this.setchart7(xAxisData, lastSeriesData, thisSeriesData);
      });
    },
    queryMonthlyThis(lastSeriesData) {
      let params = {
        flage: this.powerRegion,
        type: 1,
      };
      if (this.electricityMonth) {
        let month = this.electricityMonth.slice(-2);
        params.month = Number(month);
        let year = this.produceMonth.slice(0, 4);
        params.year = Number(year);
      }
      // monitorApi.queryMonthlyAnalysis(params).then((res) => {
      //   let object = res[0];
      //   let xAxisData = [];
      //   let thisSeriesData = [];
      //   for (const key in object) {
      //     xAxisData.push(`${key}`);
      //     thisSeriesData.push(object[key]);
      //   }
      //   
      // });
    },
    //8. 生产用能前十排名
    queryProductionEnergy() {
      this.getMonthStartAndEnd(this.produceMonth)
      let params = {
        // flage: ,
        type: this.produceRegion,
        monthStart: this.staTime,
        monthEnd: this.endTime,
      };
      // if (this.produceMonth) {
      //   let month = this.produceMonth.slice(-2);
      //   params.month = Number(month);
      //   let year = this.produceMonth.slice(0, 4);
      //   params.year = Number(year);
      // }
      monitorApi.queryProductionEnergy(params).then((res) => {
        let xAxisData = [];
        let seriesData = [];
        let object = res;
       
        object.forEach((element,index)=>{
          for (const key in element) {
            if(index <10){

              xAxisData.push(key);
              if (element[key]) {
                seriesData.push(element[key]);
              } else {
                seriesData.push(`0`);
              }
            }
            }
        })

        this.setchart8(xAxisData, seriesData);
      });
    },
    setchart1(xAxisData, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        legend: {
          show: false,
          type: "scroll",
          icon: "circle",
          right: 60,
          top: 20,
          data: ["用电量"],
          itemHeight: 10,
          textStyle: {
            fontSize: 10,
            color: "#BCCAF3",
          },
        },
        grid: {
          top: 70,
          left: 50,
          right: 60,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
              fontSize: 10,
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "用电量：MWh",
          nameTextStyle: {
            color: "#BCCAF3",
          },
          // data: [0,1000,2000,3000,4000,5000,6000],
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "用电量",
            type: "line",
            stack: "Total",
            showSymbol: true,
            symbol: "circle", // 设置为圆形空心
            lineStyle: {
              color: "#43A8EF", // 可选，设置线条颜色
              width: 1,
            },
            itemStyle: {
              borderColor: "#43A8EF", // 设置空心圆边框颜色
              color: "#020918", // 可选，设置空心圆的填充颜色
            },
            symbolSize: 6, // 设置空心圆的大小
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(31, 74, 137)",
                },
                {
                  offset: 1,
                  color: "rgb(6, 11, 31)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: seriesData,
          },
        ],
      };
      echarts.init(document.getElementById("chart1")).setOption(option);
    },
    setchart2(xAxisData, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        grid: {
          top: 80,
          left: 50,
          right: 60,
          bottom: 40,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
              fontSize: 10,
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "能耗：MWh",
          nameTextStyle: {
            color: "#BCCAF3",
          },
          // data: [0,1000,2000,3000,4000,5000,6000],
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "能耗",
            type: "line",
            stack: "Total",
            showSymbol: true,
            symbol: "circle", // 设置为圆形空心
            symbolSize: 6,
            itemStyle: {
              borderColor: "#0DB774", // 设置空心圆边框颜色
              color: "#030A24", // 可选，设置空心圆的填充颜色
            },
            lineStyle: {
              width: 1,
              color: "#0DB774",
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(13,183,116,0.38)",
                },
                {
                  offset: 1,
                  color: "rgb(13,183,116,0)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: seriesData,
          },
        ],
      };
      echarts.init(document.getElementById("chart2")).setOption(option);
    },
    setchart3(xAxisData, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        grid: {
          top: 80,
          left: 50,
          right: 0,
          bottom: 40,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
              fontSize: 10,
            },
            // formatter:function(value){
            //     return value.split('').join('\n')
            // }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "碳排统计 : (Kt)",
          nameTextStyle: {
            color: "#BCCAF3",
          },
          // data: [0,1000,2000,3000,4000,5000,6000],
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            stack: "Total",
            barWidth: 10,
            showSymbol: false,
            itemStyle: {
              normal: {
                barBorderRadius: [10, 10, 0, 0], // 设置柱状图圆角
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "#43a8ef" },
                    // { offset: 0.5, color: "#091b4d" },
                    { offset: 1, color: "#0e2769" },
                  ],
                  global: false,
                },
              },
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(13,183,116,0.38)",
                },
                {
                  offset: 1,
                  color: "rgb(13,183,116,0)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: seriesData,
          },
        ],
      };
      echarts.init(document.getElementById("chart3")).setOption(option);
      echarts.init(document.getElementById("chart3")).setOption({
        dataZoom: [
          {
            type: 'slider',    // 数据缩放类型为滑动条
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 20            // 结束位置（范围为 0 到 100）
          },
          {
            type: 'inside',    // 内置的数据缩放类型，鼠标滚轮缩放
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 100            // 结束位置（范围为 0 到 100）
          }
        ]
      });
    },
    setchart4(xAxisData, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        grid: {
          top: 80,
          left: 80,
          right: 0,
          bottom: 40,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
              fontSize: 10,
            },
            // formatter:function(value){
            //     return value.split('').join('\n')
            // }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "能耗：KWh",
          nameTextStyle: {
            color: "#BCCAF3",
          },
          // data: [0,1000,2000,3000,4000,5000,6000],
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            stack: "Total",
            barWidth: 10,
            showSymbol: false,
            itemStyle: {
              normal: {
                barBorderRadius: [10, 10, 0, 0], // 设置柱状图圆角
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "#F2BE49" },
                    // { offset: 0.5, color: "#091b4d" },
                    { offset: 1, color: "#CB9419" },
                  ],
                  global: false,
                },
              },
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(13,183,116,0.38)",
                },
                {
                  offset: 1,
                  color: "rgb(13,183,116,0)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: seriesData,
          },
        ],
      };
      echarts.init(document.getElementById("chart4")).setOption(option);
      echarts.init(document.getElementById("chart4")).setOption({
        dataZoom: [
          {
            type: 'slider',    // 数据缩放类型为滑动条
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 20            // 结束位置（范围为 0 到 100）
          },
          {
            type: 'inside',    // 内置的数据缩放类型，鼠标滚轮缩放
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 100            // 结束位置（范围为 0 到 100）
          }
        ]
      });

    },
    setchart5(xAxisData, lastSeriesData, thisSeriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          type: "scroll",
          icon: "circle",
          right: 60,
          top: 20,
          data: ["用电量"],
          itemHeight: 10,
          textStyle: {
            fontSize: 10,
            color: "#BCCAF3",
          },
        },
        grid: {
          top: 80,
          left: 50,
          right: 60,
          bottom: 40,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
              fontSize: 10,
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "能耗：MWh",
          nameTextStyle: {
            color: "#BCCAF3",
          },
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "今年用电量",
            type: "line",
            showSymbol: true,
            symbol: "circle", // 设置为圆形空心
            symbolSize: 6,
            itemStyle: {
              borderColor: "#0DB774", // 设置空心圆边框颜色
              color: "#030A24", // 可选，设置空心圆的填充颜色
            },
            lineStyle: {
              width: 1,
              color: "#0DB774",
            },
            emphasis: {
              focus: "series",
            },
            data: thisSeriesData,
          },
          {
            name: "去年用电量",
            type: "line",
            showSymbol: true,
            symbol: "circle", // 设置为圆形空心
            symbolSize: 6,
            itemStyle: {
              borderColor: "#43A8EF", // 设置空心圆边框颜色
              color: "#020918", // 可选，设置空心圆的填充颜色
            },
            lineStyle: {
              width: 1,
              color: "#43A8EF",
            },
            emphasis: {
              focus: "series",
            },
            data: lastSeriesData,
          },
        ],
      };
      echarts.init(document.getElementById("chart5")).setOption(option);
      echarts.init(document.getElementById("chart5")).setOption({
        dataZoom: [
          {
            type: 'slider',    // 数据缩放类型为滑动条
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 20            // 结束位置（范围为 0 到 100）
          },
          {
            type: 'inside',    // 内置的数据缩放类型，鼠标滚轮缩放
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 100            // 结束位置（范围为 0 到 100）
          }
        ]
      });
    },
    setchart6(xAxisData, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        grid: {
          top: 80,
          left: 40,
          right: 0,
          bottom: 40,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
              fontSize: 10,
            },
            // formatter:function(value){
            //     return value.split('').join('\n')
            // }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "能耗：MWh",
          nameTextStyle: {
            color: "#BCCAF3",
          },
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            stack: "Total",
            barWidth: 10,
            showSymbol: false,
            itemStyle: {
              normal: {
                barBorderRadius: [10, 10, 0, 0], // 设置柱状图圆角
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "#2AD58F" },
                    // { offset: 0.5, color: "#091b4d" },
                    { offset: 1, color: "#0CC076" },
                  ],
                  global: false,
                },
              },
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#2AD58F",
                },
                {
                  offset: 1,
                  color: "#0CC076",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: seriesData,
          },
        ],
      };
      echarts.init(document.getElementById("chart6")).setOption(option);
      echarts.init(document.getElementById("chart6")).setOption({
        dataZoom: [
          {
            type: 'slider',    // 数据缩放类型为滑动条
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 20            // 结束位置（范围为 0 到 100）
          },
          {
            type: 'inside',    // 内置的数据缩放类型，鼠标滚轮缩放
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 100            // 结束位置（范围为 0 到 100）
          }
        ]
      });
      
    },
    setchart7(xAxisData, lastSeriesData, thisSeriesData) {
      // 指定图表的配置项和数据
      // if(lastSeriesData.length===0)
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          type: "scroll",
          icon: "circle",
          right: 60,
          top: 40,
          data: ["今年", "去年"],
          itemHeight: 10,
          textStyle: {
            fontSize: 10,
            color: "#BCCAF3",
          },
        },
        grid: {
          top: 80,
          left: 80,
          right: 20,
          bottom: 40,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
              fontSize: 10,
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "能耗：MWh",
          nameTextStyle: {
            color: "#BCCAF3",
          },
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "今年",
            type: "line",
            // showSymbol: false,
            // symbol: "circle", // 设置为圆形空心
            // symbolSize: 6,
            // itemStyle: {
            //   borderColor: "#0DB774", // 设置空心圆边框颜色
            //   color: "#030A24", // 可选，设置空心圆的填充颜色
            // },
            lineStyle: {
              width: 1,
              color: "#43A8EF",
            },   
            emphasis: {
              focus: "series",
            },
            data: lastSeriesData,
          },
          {
            name: "去年",
            type: "line",
            // showSymbol: false,
            // symbol: "circle", // 设置为圆形空心
            // symbolSize: 6,
            // itemStyle: {
            //   borderColor: "#43A8EF", // 设置空心圆边框颜色
            //   color: "#020918", // 可选，设置空心圆的填充颜色
            // },
            lineStyle: {
              width: 1,
              color: "#0DB774",
            },
            emphasis: {
              focus: "series",
            },
            data: thisSeriesData,
          },
        ],
      };
      echarts.init(document.getElementById("chart7")).setOption(option);
      echarts.init(document.getElementById("chart7")).setOption({
        dataZoom: [
          {
            type: 'slider',    // 数据缩放类型为滑动条
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 20            // 结束位置（范围为 0 到 100）
          },
          {
            type: 'inside',    // 内置的数据缩放类型，鼠标滚轮缩放
            start: 0,          // 开始位置（范围为 0 到 100）
            end: 100            // 结束位置（范围为 0 到 100）
          }
        ]
      });
    },

    setchart8(xAxisData, seriesData) {
      // 指定图表的配置项和数据
      var option = {
        tooltip: {},
        grid: {
          top: 80,
          left: 50,
          right: 0,
          bottom: 40,
        },
        xAxis: {
          data: xAxisData,
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
              fontSize: 10,
            },
            // formatter:function(value){
            //     return value.split('').join('\n')
            // }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "能耗：MWh",
          nameTextStyle: {
            color: "#BCCAF3",
          },
          // data: [0,1000,2000,3000,4000,5000,6000],
          axisLabel: {
            textStyle: {
              color: "#BCCAF3", // 设置字体颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            stack: "Total",
            barWidth: 10,
            showSymbol: false,
            itemStyle: {
              normal: {
                barBorderRadius: [10, 10, 0, 0], // 设置柱状图圆角
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "#F2BE49" },
                    // { offset: 0.5, color: "#091b4d" },
                    { offset: 1, color: "#CB9419" },
                  ],
                  global: false,
                },
              },
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(13,183,116,0.38)",
                },
                {
                  offset: 1,
                  color: "rgb(13,183,116,0)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: seriesData,
          },
        ],
      };
      echarts.init(document.getElementById("chart8")).setOption(option);
    },
  },
};
</script>
<style scoped>
.left_nav {
  width: 30px;
  height: 30px;
  background: url("../../assets/images/monitoring/leftNav.png") no-repeat;
  position: fixed;
  z-index: 99999;
  left: 0;
  top: 5.5rem;
  cursor: pointer;
}

.row-style {
  height: 2.83rem;
  margin-bottom: 0.2rem;
  margin-left: 0.24rem;
}

/* 修改 el-select 样式  */
.el-select {
  z-index: 1990;
  position: absolute;
  right: 50px;
  top: 10px;
  width: 0.8rem;
  border: 1px solid #0e447e;
}

.el-select :deep() .el-select-dropdown {
  background: #041c4c !important;
  border: 1px solid #09295b;
  color: #aed6ff;
}

.el-select :deep() .el-select-dropdown__item.hover {
  background: #041c4c !important;
  color: #fff;
}

.el-select :deep() .el-select-dropdown__item {
  color: #aed6ff;
}

.el-select :deep() .el-select-dropdown__item.selected {
  color: #fff;
}

.el-select :deep() .el-popper[x-placement^="bottom"] .popper__arrow::after {
  top: 0;
  border-bottom-color: #041c4c;
}

.el-date-editor :deep() .el-input__inner {
  width: 100% !important;
}

.el-select :deep() .el-input__inner {
  width: 100% !important;
}

:deep() .el-input--suffix .el-input__inner {
  background: transparent !important;
  height: 0.25rem;
  width: 0.8rem;
  border: none;
  font-weight: 400;
  font-size: 12px;
  color: #d9e3ff;
}

:deep() .el-input__icon {
  height: 40px;
  position: relative;
  top: -7px;
}

.z-index {
  z-index: 2024;
}

.el-date-editor {
  z-index: 1990;
  position: absolute;
  right: 50px;
  top: 10px;
  width: 0.7rem;
  border: 1px solid #0e447e;
}

/* 修改日期选择器样式 */
::v-deep .el-icon-date {
  color: #aed6ff;
}

/* .el-select{
        position: absolute;
        right: 50px;
        top:10px;
        width: 0.8rem;
        border:1px solid #0E447E;
    } */
#monitoringRight {
  width: 1920px;
  height: 1080px;
  background: url("../../assets/images/monitoring/rightbg.jpg") no-repeat;
  background-size: 100vw;
}

.right_header {
  width: 100%;
  height: 1.08rem;
  background: url("../../assets/images/monitoring/rightHeader.png") no-repeat;
  background-size: 100vw;
}

.right_div1 {
  float: left;
  box-sizing: border-box;
  padding-top: 0.2rem;
  margin-right: 0.18rem;
  width: 1239px;
  height: 2.83rem;
  background: url("../../assets/images/monitoring/zydlssqktj.png") no-repeat;
}

.right_div1 #chart1 {
  width: 1239px;
  height: 297px;
}

.right_div2 {
  width: 6.09rem;
  height: 2.83rem;
  float: left;
  background: url("../../assets/images/monitoring/ydltj.png") no-repeat;
}

.right_div2 #chart2 {
  width: 6.09rem;
  height: 2.83rem;
}

.right_div3 {
  width: 6.09rem;
  height: 2.83rem;
  margin-right: 0.23rem;
  position: relative;
  float: left;
  background: url("../../assets/images/monitoring/ljtptj.png") no-repeat;
}

.right_div3 #chart3 {
  width: 6.09rem;
  height: 2.83rem;
}

.right_div4 {
  width: 6.09rem;
  height: 2.83rem;
  margin-right: 0.2rem;
  float: left;
  position: relative;
  background: url("../../assets/images/monitoring/dynhfx.png") no-repeat;
}

.right_div4 #chart4 {
  width: 6.09rem;
  height: 2.83rem;
}

.right_div5 {
  width: 6.09rem;
  height: 2.83rem;
  float: left;
  position: relative;
  background: url("../../assets/images/monitoring/ydltbfx.png") no-repeat;
}

.right_div5 #chart5 {
  width: 6.09rem;
  height: 2.83rem;
}

.right_div6 {
  width: 6.09rem;
  height: 2.83rem;
  margin-right: 0.2rem;
  float: left;
  position: relative;
  background: url("../../assets/images/monitoring/dyydlqktj.png") no-repeat;
}

.right_div6 #chart6 {
  width: 6.09rem;
  height: 2.83rem;
}

.right_div7 {
  width: 6.09rem;
  height: 2.83rem;
  margin-right: 0.2rem;
  float: left;
  position: relative;
  background: url("../../assets/images/monitoring/yydltbfx.png") no-repeat;
}

.right_div7 #chart7 {
  width: 6.09rem;
  height: 2.83rem;
}

.right_div8 {
  width: 6.09rem;
  height: 2.83rem;
  float: left;
  position: relative;
  background: url("../../assets/images/monitoring/scynqspm.png") no-repeat;
}

.right_div8 #chart8 {
  width: 6.09rem;
  height: 2.83rem;
}

.left_main {
  width: 5.71rem;
  height: 9.36rem;
  background: url("../../assets/images/monitoring/leftMain.png") no-repeat;
  float: left;
}

.center_main {
  float: left;
  width: 7.5rem;
  height: 7rem;
}

.right_main {
  width: 5.71rem;
  height: 9.36rem;
  background: url("../../assets/images/monitoring/rightMain.png") no-repeat;
  float: right;
}

.monitoringFooter {
  height: 1.38rem;
  margin-top: -1rem;
  background: url("../../assets/images/monitoring/rightFooter.png") no-repeat;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.header_left {
  font-size: 12px;
  color: #bccaf3;
  position: absolute;
  left: 0.5rem;
  top: 0.4rem;
}

.header_right {
  font-size: 12px;
  color: #bccaf3;
  position: absolute;
  right: 0.5rem;
  top: 0.4rem;
}

.header_left img,
.header_right img {
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.header_left span,
.header_right span {
  cursor: pointer;
  margin-right: 0.1rem;
}

.main_one {
  width: 5.71rem;
  height: 4.58rem;
  margin-bottom: 0.17rem;
  overflow: hidden;
}

.one_div {
  padding-top: 0.73rem;
  padding-left: 0.14rem;
  height: 0.61rem;
  margin-bottom: 0.13rem;
}

.main_one .two_div {
  height: 0.61rem;
  padding-left: 0.14rem;
  margin-bottom: 0.14rem;
}

.main_one .div_main {
  float: left;
  margin-right: 0.25rem;
  width: 1.81rem;
  height: 0.61rem;
  padding-left: 0.75rem;
  padding-top: 0.13rem;
  box-sizing: border-box;
}

.main_two .div_main {
  font-size: 0.12rem;
  color: #bccaf3;
}

.main_two .two_div {
  height: 0.32rem;
  width: 3.54rem;
  /* background-color: rgba(12,62,146,.11); */
  padding: 0.06rem 0.25rem 0.13rem 0.22rem;
  box-sizing: border-box;
  margin-bottom: 0.1rem;
}

.three_div {
  height: 0.41rem;
  padding-left: 0.14rem;
  margin-bottom: 0.1rem;
}

.four_div {
  height: 0.35rem;
  padding-left: 0.14rem;
  margin-bottom: 0.2rem;
}

.three_main {
  float: left;
  margin-right: 0.24rem;
}

.four_main {
  float: left;
  margin-right: 0.25rem;
}

.three_main img,
.four_main img {
  float: left;
  margin-right: 0.1rem;
}

.three_main span {
  font-size: 0.12rem;
  color: #d9e3ff;
}

.main_two {
  height: 4.63rem;
  padding-left: 0.14rem;
  padding-top: 0.69rem;
  overflow: hidden;
  box-sizing: border-box;
}

#two_footer {
  height: 2.04rem;
  width: 5.52rem;
  background: url("../../assets/images/monitoring/xwzxbg.png") no-repeat;
}

#one_echarts {
  width: 5.71rem;
  height: 2.5rem;
}

#two_echarts {
  width: 5.71rem;
  height: 2.04rem;
  margin-left: 1.6rem;
  background: url("../../assets/images/monitoring/pdxsbg.png") no-repeat;
}

#three_echarts {
  width: 5.71rem;
  height: 1.7rem;
  margin-left: 1.8rem;
  background: url("../../assets/images/monitoring/byqnxbg.png") no-repeat;
}

#four_echarts {
  width: 5.71rem;
  height: 2rem;
}

.one_title {
  width: 5.71rem;
  margin-left: 1.6rem;
  padding-left: 0.42rem;
  padding-top: 0.08rem;
  font-size: 14px;
  color: #d9e3ff;
  height: 0.32rem;
  background: url("../../assets/images/monitoring/pdxsqktj.png") no-repeat;
  box-sizing: border-box;
}
</style>
<style lang="css">
/*  */
.echarts-picker {
  background: #041c4c;
  color: #aed6ff;
  border-color: #041c4c;
}

.echarts-picker .el-picker-panel__body .el-date-picker__header-label {
  color: #aed6ff;
}

.echarts-picker .el-picker-panel__body .el-picker-panel__icon-btn {
  color: #aed6ff;
}

.echarts-picker .el-picker-panel__body .el-date-table th {
  color: #aed6ff;
  border-color: #aed6ff;
}

.echarts-picker .el-picker-panel__body .el-picker-panel__content .el-year-table .cell {
  background: #041c4c;
  color: #aed6ff;
}

.echarts-picker .el-picker-panel__body .el-picker-panel__content .el-year-table .today .cell {
  background: #041c4c;
  color: #409eff;
}

.echarts-picker .el-picker-panel__body .el-picker-panel__content .el-month-table .cell {
  background: #041c4c;
  color: #aed6ff;
}

.echarts-picker .el-picker-panel__body .el-picker-panel__content .el-month-table .today .cell {
  background: #041c4c;
  color: #409eff;
}

.echarts-picker .el-picker-panel__body .el-date-table .disabled div {
  background: #041c4c;
  color: #aed6ff;
}

.echarts-picker[x-placement^="bottom"] .popper__arrow::after {
  top: 0 !important;
  border-bottom-color: #041c4c !important;
}

.echarts-picker[x-placement^="top"] .popper__arrow::after {
  bottom: 0 !important;
  border-top-color: #041c4c !important;
}
</style>
